const blocks = document.querySelectorAll( '.b-language-switcher' );

blocks.forEach( ( block ) => {

	const mobileButton = block.querySelector( '.b-language-switcher__current-button' );
	const mobileDropdown = block.querySelector( '.b-language-switcher__dropdown--mobile' );

	const desktopButton = block.querySelector( '.b-language-switcher__current--desktop' );
	const desktopList = block.querySelector( '.b-language-switcher__list--desktop' );

	if ( mobileButton && mobileDropdown ) {

		mobileButton.addEventListener( 'click', () => {

			mobileDropdown.classList.toggle( 'b-language-switcher__dropdown--active' );

		} );

		const innerCurrent = mobileDropdown.querySelector( '.b-language-switcher__current--mobile' );
		if ( innerCurrent ) {

			innerCurrent.addEventListener( 'click', () => {

				mobileDropdown.classList.remove( 'b-language-switcher__dropdown--active' );

			} );

		}

	}

	if ( desktopButton && desktopList ) {

		desktopButton.addEventListener( 'click', () => {

			desktopList.classList.toggle( 'b-language-switcher__list--active' );

		} );

	}

} );

document.addEventListener( 'click', ( e ) => {

	blocks.forEach( ( block ) => {

		if ( !block.contains( e.target ) ) {

			const mobileDropdown = block.querySelector( '.b-language-switcher__dropdown--mobile' );
			if ( mobileDropdown ) {

				mobileDropdown.classList.remove( 'b-language-switcher__dropdown--active' );

			}

			const desktopList = block.querySelector( '.b-language-switcher__list--desktop' );
			if ( desktopList ) {

				desktopList.classList.remove( 'b-language-switcher__list--active' );

			}

		}

	} );

} );
